import { Card } from "@material-ui/core";
import { useSelector } from "react-redux";
import { GetConfigData } from "store/config/selectors";

import path from "path";

type BusinessCardProps = {
  cardId: string;
  builderType: string;
  cardImage: string;
};

export const BusinessCard = ({
  cardId,
  builderType,
  cardImage,
}: BusinessCardProps) => {
  const confData = useSelector(GetConfigData);

  const imagePath = new URL(
    builderType === "PRO"
      ? "/assets/htmlcards/" + cardId
      : "/assets/enterprise_templates/" + cardId,
    confData.filesBaseUrl
  );

  return (
    <Card style={{ marginTop: "5px" }}>
      <img
        src={`${imagePath}.${
          builderType === "PRO" ? cardImage.split(".")[1] : "jpg"
        }?q=${Date.now()}`}
        alt="samle card"
        style={{ display: "flex", width: "100%" }}
      />
    </Card>
  );
};
